import React from "react";
import { Link } from "react-router-dom";

function SubscriptionDetailsSection() {
    return (
        <div className="account__section">
            <div className="account__section__colLeft">
                <div className="account__section__colLeft_title">
                    Subscription details
                    <a href="" className="account__section__colRight__plan__free account__section__colRight__plan__free--mobile">
                        <img src="./assets/img/user_account/star-green.png" alt="" /> Free Plan
                    </a>
                </div>
                <div className="account__section__colLeft_description"></div>
            </div>
            <div className="account__section__colRight">
                <div className="account__section__colRight__plan">
                    <a href="" className="account__section__colRight__plan__free">
                        <img src="./assets/img/user_account/star-green.png" alt="" />Free Plan
                    </a>
                </div>
                <div className="account__section__colRight__benefits">
                    <div className="account__section__colRight__benefits__col">
                        <span className="pb-xs"><span className="account__section__colRight__benefits__col__symbol">+</span> Unlimited surveys</span>
                        <span className="pb-xs"><span><span className="account__section__colRight__benefits__col__symbol">+</span> Template gallery access</span></span>
                        <span><span className="account__section__colRight__benefits__col__symbol">+</span> Access to all question types</span>
                    </div>
                    <div className="account__section__colRight__benefits__col">
                        <span className="pb-xs"><span className="account__section__colRight__benefits__col__symbol">+</span> Unlimited respondents</span>
                        <span className="pb-xs"><span><span className="account__section__colRight__benefits__col__symbol">+</span> Web reports, PPT & CSV exports</span></span>
                        <span><span className="account__section__colRight__benefits__col__symbol">+</span> Question logic conditions</span>
                    </div>
                </div>
                <div className="account__section__colRight__action">
                    <Link to="/pricing" onClick={()=>window.scrollTo(0,0)} className="account__section__colRight__action__upgrade">Upgrade</Link>
                </div>
            </div>
        </div>
    );
}

export default SubscriptionDetailsSection;